import { createStore } from 'zustand/vanilla';
import { ApiService } from '@/infrastructure/api/ApiService';
import { Category, Status } from './types/campaign.interface';
import type { Merchant } from './types/merchant.interface';
import type { Metadata } from './types/metadata.interface';

export interface CorporateStore {
	corporateId: string;
	filters: {
		status?: Status;
		year?: string;
		category?: Category;
	};
	merchant: Merchant;
	metadata: Metadata;
	corporatesApiService: ApiService;
	clearFilters: () => void;
	setFilter: <K extends keyof CorporateStore['filters']>(key: K, value: CorporateStore['filters'][K]) => void;
}

export function createCorporateStore(corporateId: string, metadata: Metadata, merchant: Merchant) {
	return createStore<CorporateStore>()((set) => ({
		//Initial state
		corporateId,
		metadata,
		merchant,
		corporatesApiService: new ApiService(),
		filters: {},
		clearFilters: () => set((state) => ({ ...state, filters: {} })),
		setFilter: (key, value) => set((state) => ({ ...state, filters: { ...state.filters, [key]: value } })),
	}));
}
